export default "__VITE_ASSET__Dw1X8G2R__"